import type {
  AdvanceChainRunResponse,
  ChainRunDetail,
  ChainRunFilters,
  ChainRunSummary,
  PagedResult,
  PaginationParams,
} from '@/types'
import { client } from './client'

interface ChainRunQueryParams {
  search?: string
  status?: string
  chainDefinitionId?: string
  linkedEntityId?: string
  triggerSource?: string
  maxResultCount?: number
  skipCount?: number
}

function buildQueryParams(filters?: ChainRunFilters, pagination?: PaginationParams): ChainRunQueryParams {
  const params: ChainRunQueryParams = {}

  if (filters?.search) {
    params.search = filters.search
  }
  if (filters?.status) {
    params.status = filters.status
  }
  if (filters?.chainDefinitionId) {
    params.chainDefinitionId = filters.chainDefinitionId
  }
  if (filters?.linkedEntityId) {
    params.linkedEntityId = filters.linkedEntityId
  }
  if (filters?.triggerSource) {
    params.triggerSource = filters.triggerSource
  }

  if (pagination?.maxResultCount) {
    params.maxResultCount = pagination.maxResultCount
  }
  if (pagination?.skipCount) {
    params.skipCount = pagination.skipCount
  }

  return params
}

export const chainRunsApi = {
  getAll: (projectId: string, filters?: ChainRunFilters, pagination?: PaginationParams) =>
    client.get<PagedResult<ChainRunSummary>>(`/projects/${projectId}/chains/runs`, {
      params: buildQueryParams(filters, pagination),
    }).then(r => r.data),

  getById: (projectId: string, chainRunId: string) =>
    client.get<ChainRunDetail>(`/projects/${projectId}/chains/runs/${chainRunId}`).then(r => r.data),

  advance: (projectId: string, chainRunId: string, inputValuesJson?: string) =>
    client.post<AdvanceChainRunResponse>(`/projects/${projectId}/chains/runs/${chainRunId}/advance`, {
      inputValuesJson,
    }).then(r => r.data),
}
